/* eslint-disable */
import React from "react";
import themePropTypes from "../theme-prop-types";

const GraphBar = ({ barHeight, color, showDivider, calculateBarHeight }) => {
  return (
    <div
      className={`graph-bar-web-sdk ${
        showDivider ? "divider-active" : "divider-inactive"
      }`}
      data-testid='graph-bar-web-sdk'
      style={{
        height: `${calculateBarHeight(barHeight)}px`,
        backgroundColor: `#${color?.substring(2, 8)}`
      }}
    ></div>
  );
};

GraphBar.propTypes = themePropTypes.graph;
export default GraphBar;
